import React from "react";
import { usePortfolio } from "../hooks/usePortfolio";
import ParticleBackground from "./ParticleBackground";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Experience from "./sections/Experience";
import Projects from "./sections/Projects";
import Skills from "./sections/Skills";
import Education from "./sections/Education";
import Achievements from "./sections/Achievements";
import Contact from "./sections/Contact";

const Portfolio = () => {
  const { data, loading } = usePortfolio();

  if (loading || !data) {
    return (
      <>
        <ParticleBackground />
        <div className="min-h-screen flex items-center justify-center">
          <div className="flex flex-col items-center gap-3">
            <div className="w-12 h-12 rounded-full border-2 border-cyan-400/30 border-t-cyan-400 animate-spin" />
            <span className="font-mono text-[10px] tracking-[0.4em] uppercase text-slate-500">Loading portfolio</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {(data.settings?.show_particles !== false) && <ParticleBackground />}
      <Navbar hero={data.hero} />
      <main data-testid="portfolio-main">
        <Hero hero={data.hero} settings={data.settings} />
        <About hero={data.hero} />
        <Experience items={data.experiences} />
        <Projects items={data.projects} />
        <Skills items={data.skills} />
        <Education items={data.education} certifications={data.certifications} />
        <Achievements items={data.achievements} />
        <Contact contact={data.contact} hero={data.hero} />
      </main>
      <Footer contact={data.contact} hero={data.hero} />
    </>
  );
};

export default Portfolio;
